

import { HeaderInfoService } from './../../../servicios/header-info.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { SocketService } from 'src/app/services/socket.service';
import { Subscription } from 'rxjs';
import { VisitantesService, Visitante } from 'src/app/servicios/visitantes.service';


@Component({
  selector: 'app-pagina-visitantes',
  templateUrl: './pagina-visitantes.component.html',
  styleUrls: ['./pagina-visitantes.component.scss']
})
export class PaginaVisitantesComponent implements OnInit, OnDestroy {
  private ignoreFirstSocketEvent = true;
  // Estados de tabs
  estadosTabs: { label: string; value: number | string | undefined }[] = [
    { label: 'TODOS', value: '' },
    { label: 'VISITAS PROGRAMADAS', value: 1 },
    { label: 'ENROLADOS', value: 2 },
    { label: 'EN PLANTA', value: 3 },
    { label: 'RECHAZADO', value: 4 },
    { label: 'SALIDA', value: 5 },
    { label: 'HISTORIAL', value: 0 }
  ];
  estadoSeleccionado: number | string | undefined = '';
  visitantes: Visitante[] = [];
  private socketSub: Subscription | undefined;
  unidadId: number = 0;

  public displayedColumns: any[] = [
    {
      nombre: 'nombreVisitante',
      titulo: 'Nombre Visitante',
      valueFieldName: 'name'
    },
    {
      nombre: 'area',
      titulo: 'Área',
      valueFieldName: 'area_name'
    },
    {
      nombre: 'apartamento',
      titulo: 'Unidad',
      valueFieldName: 'site_name'
    },
    {
      nombre: 'documento',
      titulo: 'No. de identidad',
      valueFieldName: 'number_document'
    },
    {
      nombre: 'fechaLlegada',
      titulo: 'Fecha/Hora llegada',
      valueFieldName: 'hour_checkin'
    },
    {
      nombre: 'fechaSalida',
      titulo: 'Fecha/Hora salida',
      valueFieldName: 'hour_checkout'
    },
    {
      nombre: 'estado',
      titulo: 'Estado',
      valueFieldName: 'status'
    },
    {
      nombre: 'vehiculo',
      titulo: 'Vehículo',
      valueFieldName: 'vehiculo'
    },
    // {
    //   nombre: 'comentario',
    //   titulo: 'Comentario',
    //   valueFieldName: 'note'
    // },
  ];

  constructor(
    private headerInfoService: HeaderInfoService,
    private socketService: SocketService,
    private visitantesService: VisitantesService
  ) {
    // Obtener el id de la unidad residencial desde localStorage
    const dataString = localStorage.getItem('data_login');
    if (dataString) {
      try {
        const data_login = JSON.parse(dataString);
        this.unidadId = data_login?.company_id || 0;
        console.log('[Visitantes] Unidad ID:', this.unidadId, '| Perfil:', data_login?.role);
      } catch (e) {
        this.unidadId = 0;
        console.error('[Visitantes] Error parseando data_login:', e);
      }
    } else {
      this.unidadId = 0;
      console.warn('[Visitantes] No se encontró data_login en localStorage');
    }
  }


  onTipoVisitasChange(nuevoTipo: number): void {
    this.estadoSeleccionado = nuevoTipo;
  }

  cargarVisitantes(): void {
    this.visitantesService.traerVisitantes(0, this.estadoSeleccionado as any, '', '', '', '', '').subscribe({
      next: (res: any) => {
        this.visitantes = res?.data?.visitantes || [];
        console.log('Visitantes actualizados:', this.visitantes);
      },
      error: (err: any) => {
        this.visitantes = [];
        console.error('Error al obtener visitantes:', err);
      }
    });
  }

  ngOnInit() {
    this.headerInfoService.cambiarTituloPagina("VISITANTES");
    this.headerInfoService.cambiarTituloTarjeta("¡Bienvenido a visitantes!");
    this.headerInfoService.cambiarTextoTarjeta("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo.");
    // this.headerInfoService.cambiarImagenTarjeta('./../../../../assets/header/pagina-principal-lugares.svg');

    // Cargar visitantes con el tab seleccionado al iniciar
    this.cargarVisitantes();

    // Suscribirse a eventos de la unidad por WebSocket
    console.log('[Visitantes] Suscribiéndose a WebSocket para unidadId:', this.unidadId);
    this.socketSub = this.socketService.listenUnidad(this.unidadId)
      .subscribe(data => {
        // Ignorar el primer evento recibido tras la suscripción
        if (this.ignoreFirstSocketEvent) {
          this.ignoreFirstSocketEvent = false;
          console.log('[Visitantes] Primer evento WebSocket ignorado (handshake).');
          return;
        }
        console.log('[Visitantes] Evento WebSocket recibido:', data, '| estadoSeleccionado:', this.estadoSeleccionado);
        // Siempre usar el estadoSeleccionado actual (tab activo)
        this.cargarVisitantes();
      });
  }

  ngOnDestroy() {
    if (this.socketSub) this.socketSub.unsubscribe();
  }
}
